const drugsProps = [
  // key === JSON nossa API
  { key: "name", name: "nome" },
  { key: "description", name: "descricao" },
  { key: "dosage", name: "posologia" },
  { key: "sanitized_posology", name: "sanitized_posology" },
  { key: "quantity", name: "quantidade" },
  { key: "composition", name: "composicao" },
  { key: "manufacturer", name: "fabricante" },
  { key: "ownership", name: "titularidade" },
  { key: "special_control", name: "controle_especial" },
  { key: "high_cost", name: "alto_custo" },
  { key: "quantity_month_1", name: "quantity_month_1" },
  { key: "quantity_month_2", name: "quantity_month_2" },
  { key: "quantity_month_3", name: "quantity_month_3" },
  { key: "anamnesis", name: "anamnese" },
  { key: "previous_treatment", name: "tratamento_previo" },
  { key: "request_data", name: "data_solicitacao" },
  { key: "cide_id", name: "cid_id" },
  { key: "prescription_type", name: "tipo" },
  { key: "sus_exam_code", name: "exames_sus_codigo" },
  { key: "tuss_exam_code", name: "exames_tuss_codigo" },
  { key: "selected_exam_type", name: "tipo_exame_selecionado" },
  { key: "catmat_code_br", name: "catmat_codigo_br" },
  { key: "catmat_description", name: "catmat_descricao" },
  { key: "cid_description", name: "cid_descricao" },
  { key: "cid_numero", name: "cid_numero" },
  { key: "price", name: "preco" },
  { key: "tarja", name: "tarja" },
  { key: "drug_type", name: "tipo" },
  { key: "memed_id", name: "id" },
  { key: "destroy", name: "catmat_codigo_br" }
];

export default drugs => {
  const drugs_attributes = [];
  const dePara = drugs.map(drug => {
    const keys = Object.keys(drug).map(drugKey => {
      const hashKey = !drugsProps.find(prop => prop.name === drugKey)
        ? undefined
        : drugsProps.find(prop => prop.name === drugKey).key;
      if (hashKey) {
        return {
          key: hashKey,
          value: drug[drugKey]
        };
      }
    });
    return keys;
  });
  dePara.map(item => {
    let output = {};
    for (let i = 0; i <= item.length; i++) {
      if (item[i]) {
        output[item[i].key] = item[i].value;
      }
    }
    drugs_attributes.push(output);
  });
  return drugs_attributes;
};
